module.exports = __webpack_public_path__ + "static/media/south-korea.91cdcbe9.svg";